import React from "react";
import Axios from 'axios';
import GerenteTemplate from './GerenteTemplate';

export class PerfilGerente extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      statusVenda: false,
      bloqVendas: JSON.parse(localStorage.getItem("user")).bloqVendas
    };
  }

  getUser = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/user", {
        id: this.state.user._id
      });

      window.localStorage.setItem("user", JSON.stringify(response.data[0]));
      this.setState({ user: response.data[0] });
    } catch (err) {
      console.log(err);
    }
  };

  async statusVenda() {
    try {
        var axiosInstance = new Axios.create({
            baseURL: window.localStorage.getItem('apiUrl')
        })
        const response = await axiosInstance.get('parametros/venda-status', {})
        this.setState({ statusVenda: response.data })
    } catch (err) {
        console.log(err)
    }
}

async userBloqVendas(bloqVendas) {
  console.log(bloqVendas)
  try {
      var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem('apiUrl')
      })
      await axiosInstance.post('usuarios/bloq-vendas', {_id: this.state.user._id, bloqVendas : bloqVendas})
  } catch (err) {
      console.log(err)
  }
}


bloquearVendas (e){
  if(!this.state.statusVenda){
    this.state.bloqVendas = e.target.checked;
    this.state.user.bloqVendas = e.target.checked
    this.setState({bloqVendas : e.target.checked})
    this.userBloqVendas(e.target.checked)
    this.setState({user : this.state.user})
    localStorage.setItem('user', JSON.stringify(this.state.user))
  }
}

  render() {
    return (
      <GerenteTemplate>
        
            <div class="content">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-8">
                    <div class="card">
                      <div class="card-header">
                        <h4 class="card-title">Perfil</h4>
                      </div>
                      <div class="card-body">
                        <form>
                          <div class="row">
                            <div class="col-md-3 px-1">
                              <div class="form-group">
                                <label>Nome</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  disabled
                                  placeholder="Nome"
                                  value={this.state.user.nome}
                                />
                              </div>
                            </div>
                            <div class="col-md-4 pl-1">
                              <div class="form-group">
                                <label for="exampleInputEmail1">Email</label>
                                <input
                                  type="email"
                                  disabled
                                  class="form-control"
                                  placeholder="Email"
                                  value={this.state.user.email}
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6 pr-1">
                              <div class="form-group">
                                <label>CPF</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  disabled
                                  placeholder="CPF"
                                  value={this.state.user.cpf}
                                />
                              </div>
                            </div>
                            <div class="col-md-6 pl-1">
                              <div class="form-group">
                                <label>Comissão</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control"
                                  placeholder="Comissão"
                                  value={this.state.user.comissao}
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <label>Endereço</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control"
                                  placeholder="Endereço"
                                  value={this.state.user.endereco}
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4 pr-1">
                              <div class="form-group">
                                <label>Cidade</label>
                                <input
                                  disabled
                                  type="text"
                                  class="form-control"
                                  placeholder="City"
                                  value={this.state.user.cidade}
                                />
                              </div>
                            </div>
                            <div class="col-md-4 px-1">
                              <div class="form-group">
                                <label>Bairro</label>
                                <input
                                  disabled
                                  type="text"
                                  class="form-control"
                                  placeholder="Bairro"
                                  value={this.state.user.bairro}
                                />
                              </div>
                            </div>
                            <div class="col-md-4 pl-1">
                              <div class="form-group">
                                <label>Status</label>
                                <input
                                  disabled
                                  type="text"
                                  class="form-control"
                                  placeholder="Status"
                                  value={
                                    this.state.user.status
                                      ? "Ativo"
                                      : "Bloqueado"
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                          <div class="pl-2">
                          <div class="pl-2">
                              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <label style={{marginLeft: 6, fontWeight: 'bold', fontSize: 12, marginTop: 8}}>Bloquear vendas Online</label>
                                <input disabled={this.state.statusVenda} type="checkbox" style={{marginLeft: 6, width: 22, height: 22, fontSize: 12}} onChange={this.bloquearVendas.bind(this)}  checked={this.state.bloqVendas}></input>
                              </div>
                          </div>
                          </div>
                          </div>
                          <div class="clearfix"></div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
      </GerenteTemplate>
    );
  }
}

export default PerfilGerente;
